// extracted by mini-css-extract-plugin
export var arrow = "_eh-1";
export var content = "_eh-0";
export var highlighted = "_eh-2";